import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import CooperationEventModel from '../../model/cooperationEvent.model';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import {catchError, switchMap} from 'rxjs/operators';
import InsightModel from '../../model/insight.model';

@Injectable()
export default class InsightService {
  public constructor(private http: HttpClient) {
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string): Observable<Pagination<InsightModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 15;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    return this.http
      .get<Pagination<InsightModel>>(environment.apiUrl + '/insights?' + QueryEncoder.encodeURI(q));
  }

  public create(insight: InsightModel): Observable<InsightModel> {
    return this.http
      .post<InsightModel>(environment.apiUrl + '/insights', insight);
  }

  public update(insight: InsightModel): Observable<any> {
    return this.http.put(environment.apiUrl + '/insights/' + insight.id, insight);
  }

  public delete(insight: InsightModel): Observable<boolean> {
    return this.http.delete(environment.apiUrl + '/insights/' + insight.id).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }
}
